import { getPolygonTypes } from "../../store/actions/Polygon";
import { Api } from "../config/request";

export default {
  getPolygonList(queryParams) {
    return Api.get(`/locations/polygon${queryParams}`);
  },
  getPolygon(payload) {
    const id = payload.id;
    return Api.get(`/locations/polygon/${id}`);
  },
  updatePolygon(id, payload) {
    return Api.put(`/locations/polygon/${id}`, payload);
  },
  createPolygon(payload) {
    return Api.post("/locations/polygon", payload);
  },
  getPolygonTypes() {
    return Api.get("/locations/polygon-types");
  }
};
